import React from 'react';
export function Card({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`rounded-2xl bg-white border border-[#E8E8ED] shadow-sm ${className || ''}`} data-id="element-1182">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`flex flex-col space-y-1.5 p-6 ${className || ''}`} data-id="element-1183">
      {children}
    </div>;
}
export function CardTitle({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h3 className={`font-semibold leading-none tracking-tight text-[#2D2D2D] ${className || ''}`} data-id="element-1184">
      {children}
    </h3>;
}
export function CardContent({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`p-6 pt-0 ${className || ''}`} data-id="element-1185">{children}</div>;
}